import React from "react";
import { Button, ScrollView, Text, XStack, YStack, Separator } from "tamagui";

interface SensorValueRow {
  timestamp: number | string;
  eventType: string;
  [key: string]: any; // For dynamic value fields
}

interface SensorDataTableProps {
  valueRows: SensorValueRow[];
  valueColumns: string[];
  formatTimestamp: (timestamp: number | null | undefined) => string;
  downloadCSV: () => void;
}

export const SensorDataTable: React.FC<SensorDataTableProps> = ({
  valueRows,
  valueColumns,
  formatTimestamp,
  downloadCSV,
}) => (
  <YStack
    backgroundColor="$backgroundHover"
    padding="$3"
    borderRadius="$4"
    space="$2"
    flex={1}
  >
    <XStack justifyContent="space-between" alignItems="center">
      <Text fontSize="$4" fontWeight="bold">
        Sensor Data Table
      </Text>
      <Button onPress={downloadCSV} size="$2" theme="green">
        Download CSV
      </Button>
    </XStack>
    <Separator marginVertical="$2" />

    {valueRows.length === 0 ? (
      <Text padding="$4" textAlign="center">
        No detailed data available for the selected sensor.
      </Text>
    ) : (
      <YStack flex={1}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={true}
          paddingBottom="$2"
        >
          <YStack>
            {/* Header Row */}
            <XStack
              backgroundColor="$backgroundStrong"
              padding="$2"
              borderRadius="$4"
              marginBottom="$2"
            >
              <Text minWidth={150} fontWeight="bold" marginRight="$2">
                Timestamp
              </Text>
              <Text minWidth={100} fontWeight="bold" marginRight="$2">
                Event Type
              </Text>
              {/* Dynamic columns for sensor values */}
              {valueColumns.map((col) => (
                <Text
                  key={col}
                  minWidth={120}
                  fontWeight="bold"
                  marginRight="$2"
                >
                  {col}
                </Text>
              ))}
            </XStack>

            {/* Data Rows */}
            <ScrollView style={{ maxHeight: 400 }}>
              {valueRows.map((row, rowIndex) => (
                <XStack
                  key={rowIndex}
                  padding="$2"
                  borderRadius="$4"
                  backgroundColor={
                    rowIndex % 2 === 0 ? "$background" : "$backgroundHover"
                  }
                >
                  <Text minWidth={150} marginRight="$2">
                    {formatTimestamp(row.timestamp)}
                  </Text>
                  <Text minWidth={100} marginRight="$2">
                    {row.eventType}
                  </Text>
                  {/* Dynamic cells for sensor values */}
                  {valueColumns.map((col) => (
                    <Text key={col} minWidth={120} marginRight="$2">
                      {row[col] !== undefined
                        ? typeof row[col] === "object"
                          ? JSON.stringify(row[col])
                          : String(row[col])
                        : "-"}
                    </Text>
                  ))}
                </XStack>
              ))}
            </ScrollView>
          </YStack>
        </ScrollView>
      </YStack>
    )}
  </YStack>
);
